import MoreVertIcon from '@mui/icons-material/MoreVert';
import tableimg from 'assets/images/TableImg.svg';

export const CustomerData =
{
  header: [
    {
      label: 'ID',
      key: 'id',
    },

    {
      label: 'Name',
      key: 'name',
    },

    {
      label: 'Mobile',
      key: 'mobile',
    },
    {
      label: 'Join Date',
      key: 'joindate',
    },
    {
      label: 'Email',
      key: 'email',
    },
    {
      label: 'Location',
      key: 'location',

    },
    {
      label: 'Completed Trip',
      key: 'completedtrip',
    },
    {
      label: '',
      key: 'icon',
    },
  ],
  body: [
    {
      id: '1',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '2',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '3',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '5',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '5',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '6',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
    {
      id: '7',
      name: 'Rahul Kumar',
      image: tableimg,
      mobile: '8989891213',
      joindate: '12 may 2023',
      email: 'abc@example.com',
      location: 'Bangalore',
      completedtrip: '4',
      icon: <MoreVertIcon />
    },
  ],
}
export const filterdataCustomer = [
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'Blocked', key: 'Status' }
    ]
  },
  // {
  //   id: 2,
  //   primaryText: 'Location',
  //   subItems: [
  //     { value: 'Bangalore', key: 'Location' },
  //     { value: 'Chennai', key: 'Location' },
  //     { value: 'Mysore', key: 'Location' },
  //     { value: 'Kannur', key: 'Location' }
  //   ]
  // }
];